import "./banner-card.scss";

import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";

import useDesktopChecker from "hooks/useDesktopChecker";

export interface BannerCardProps {
  readonly title: string;
  readonly subtitle?: string;
  readonly ctaLabel: string;
  readonly onCTAClick: () => void;
  readonly onDismiss?: () => void;
  readonly icon?: IconProp;
  readonly variant?: "desktop" | "mobile";
  readonly className?: string;
  readonly ariaLabel?: string;
  readonly ctaAriaLabel?: string;
  readonly dismissAriaLabel?: string;
}

export function BannerCard({
  title,
  subtitle,
  ctaLabel,
  onCTAClick,
  onDismiss,
  icon,
  variant,
  className,
  ariaLabel,
  ctaAriaLabel,
  dismissAriaLabel = "Dismiss banner",
}: BannerCardProps) {
  const hookIsDesktop = useDesktopChecker();
  const isDesktop = variant ? variant === "desktop" : hookIsDesktop;

  return (
    <div
      className={classNames(
        "banner-card",
        { "banner-card--desktop": isDesktop, "banner-card--mobile": !isDesktop },
        className
      )}
      aria-label={ariaLabel ?? title}
    >
      {isDesktop && icon && (
        <span className="banner-card__icon" aria-hidden="true">
          <FontAwesomeIcon icon={icon} />
        </span>
      )}

      <div className="banner-card__text">
        <span className="label-large-medium banner-card__title">{title}</span>
        {isDesktop && subtitle && (
          <span className="label-large-medium banner-card__separator" aria-hidden="true">·</span>
        )}
        {subtitle && <span className="banner-card__subtitle">{subtitle}</span>}
      </div>

      <button
        type="button"
        className="label-small-medium banner-card__cta"
        onClick={onCTAClick}
        aria-label={ctaAriaLabel ?? ctaLabel}
      >
        {ctaLabel}
      </button>

      {onDismiss && (
        <button
          type="button"
          className="banner-card__close"
          onClick={onDismiss}
          aria-label={dismissAriaLabel}
        >
          <FontAwesomeIcon icon={solid("xmark")} />
        </button>
      )}
    </div>
  );
}

export default BannerCard;
